import { ReactComponent as TrashIcon } from 'assets/icons/garbage.svg';
import React from 'react';
import './TriggerSidePaneQuestionItem.scss';

type Props = {
  questionText: string;
  count: string;
  onIgnore: () => void;
};

export const TriggerSidePaneQuestionItem = ({
  questionText,
  count,
  onIgnore,
}: Props) => (
  <div className="trigger-side-pane-question-item">
    <div className="trigger-side-pane-question-item__heading">
      <div className="trigger-side-pane-question-item__question-text">
        {questionText}
      </div>
      <div className="trigger-side-pane-question-item__info">
        <div className="trigger-side-pane-question-item__count">{count}</div>
        <div>
          <TrashIcon
            onClick={onIgnore}
            className="trigger-side-pane-question-item__button"
          />
        </div>
      </div>
    </div>
  </div>
);
